import { Badge, Space } from 'antd'
import type { BadgeProps } from 'antd'

interface StatusBadgeProps {
  label: string
  status?: BadgeProps['status']
}

export function StatusBadge({ label, status = 'default' }: StatusBadgeProps) {
  return (
    <Space size={6}>
      <Badge status={status} />
      <span>{label}</span>
    </Space>
  )
}
